import React from 'react';
import './CSS/contact.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faYoutube, faEtsy } from '@fortawesome/free-brands-svg-icons';

function Contact() {
  return (
    <section id="contact">

      <h1 class="monoton_title contact-title">CONTACT</h1>

      <div class="contact-wrapper">

        <form class="form-horizontal" method="POST" name="contact">
          <input type="hidden" name="form-name" value="contact" /> 
          <div class="form-group">
            <div class="col-sm-12">
              <input class="form-control" id="name" placeholder="NAME" name="name" />
            </div>
          </div>
          <div class="form-group">
            <div class="col-sm-12">
              <input class="form-control" id="email" placeholder="EMAIL" name="email" />
            </div>
          </div>
          <textarea class="form-control" rows="10" placeholder="MESSAGE" name="message"></textarea>
          <div class="button-container">
            <button class="btn btn-primary send-button" id="submit" type="submit" value="SEND">SEND</button>
          </div>
        </form>
  
        <div class="direct-contact-container">
          <ul class="contact-list">
            <li class="list-item"><i class="fa fa-map-marker fa-2x"><span class="contact-text place">Chesterfield, UK</span></i></li>
            <li class="list-item"><i class="fa fa-phone fa-2x"><span class="contact-text phone" title="Give me a call">07790447615</span></i></li>
            <li class="list-item"><i class="fa fa-envelope fa-2x"><span class="contact-text gmail"><a href="mailto:#" title="Send me an email">davidjelsom@hotmail.com</a></span></i></li>
          </ul>
          <hr/>
          <div className="icon__container">
            <a target="blank" href="https://www.instagram.com/sombrero_printmaking/?hl=en"><FontAwesomeIcon icon={faInstagram} /></a>
            <a target="blank" href="https://www.facebook.com/Sombrero_Printmaking-215020229059381/?eid=ARDq1yIzaOX02Vrnpt3r_6gnGYY_vamnUOcgS7DBin-5JHmxeUqz7kmo1Jwfj6REyvb9WszH3A7FHvyF"><FontAwesomeIcon icon={faFacebook} /></a>
            <a target="blank" href="https://www.youtube.com/channel/UCDsRAuVhZ2uS0E2nwgiLPQA"><FontAwesomeIcon icon={faYoutube} /></a>
            <a target="blank" href="https://www.etsy.com/uk/shop/SombreroPrintmaking"><FontAwesomeIcon icon={faEtsy} /></a>
          </div>
          <hr/>
        </div>
      </div>
    </section>  
  );
}

export default Contact;
